export const onboardingIntroChat = (state) => {
  return state?.onboarding?.introChat || {};
};

export const onboardingIntroChatMessages = (state) => {
  return Array.isArray(state?.onboarding?.introChat?.messages) ? state.onboarding.introChat.messages : [];
};

export const onboardingIntroChatName = (state) => {
  return String(state?.onboarding?.introChat?.name || '').trim();
};

export const onboardingIntroChatJob = (state) => {
  return String(state?.onboarding?.introChat?.job || '').trim();
};

export const onboardingIntroChatJobFamily = (state) => {
  return state?.onboarding?.introChat?.jobFamily || null;
};

export const onboardingIntroChatIsDevRole = (state) => {
  return typeof state?.onboarding?.introChat?.isDevRole === 'boolean' ? state.onboarding.introChat.isDevRole : null;
};

export const onboardingIntroChatShouldSkipOnboarding = (state) => {
  return state?.onboarding?.introChat?.shouldSkipOnboarding === true;
};

export const isOnboardingIntroChatComplete = (state) => {
  return onboardingIntroChatShouldSkipOnboarding(state) || Boolean(onboardingIntroChatName(state) && onboardingIntroChatJob(state));
};
